export default function TestAccountBadge({ show, className = '' }) {
  if (!show) return null
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-xs font-sans font-semibold uppercase tracking-wider bg-yellow-500/15 text-yellow-400 border border-yellow-500/30 rounded-sm ${className}`}
      title="Internal test account — excluded from academy revenue"
    >
      Test
    </span>
  )
}
